import React, { FunctionComponent } from 'react';

import { VignetteCarousel as VignetteCarouselType } from '@gojob/cms';
import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';
import { graphql } from 'gatsby';

import BreakpointContainer from '../../BreakpointContainer';
import Buttons from '../../Buttons';
import VignetteScroller from '../../VignetteScroller';

export const VignetteCarouselFragment = graphql`
  fragment VignetteCarouselFragment on SanityVignettes {
    title {
      title
      level
    }
    disable_scroller
    variant {
      variant
    }
    ctas {
      ...CtaFragment
    }
    vignette_cards {
      title
      body: _rawBody
      image {
        alt
        hotspot {
          x
          y
        }
        asset {
          localFile {
            childImageSharp {
              gatsbyImageData(width: 920, placeholder: BLURRED)
            }
          }
        }
      }
    }
  }
`;

const useStyles = () => {
  const { spacing } = useTheme();
  return {
    title: {
      textAlign: 'center',
      margin: spacing(4, 4, 6),
    },
  } as const;
};

const VignetteCarousel: FunctionComponent<VignetteCarouselType> = (props) => {
  const { vignette_cards = [], disable_scroller, ctas } = props;
  const { title, level = 'h2' } = props.title || {};
  const classes = useStyles();

  return (
    <BreakpointContainer
      padding={{ xs: [0, 0, 4], md: [4, 0] }}
      width="100%"
      flexDirection="column"
      alignItems="stretch"
      maxWidth="xl"
    >
      {title && (
        <Text variant="headline1" as={level} gutter={8} css={classes.title}>
          {title}
        </Text>
      )}

      <VignetteScroller disableScroller={disable_scroller} items={vignette_cards} />

      {ctas?.length ? (
        <Flex flexDirection="column" alignItems="center" padding={{ xs: [0, 4], md: [4, 0, 0] }}>
          <Buttons ctas={ctas} />
        </Flex>
      ) : null}
    </BreakpointContainer>
  );
};

export default VignetteCarousel;
